import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import type { ReactElement } from 'react';

import AuthLayout from '../../../../components/layout/AuthLayout/AuthLayout';
import { FindPasswordPageItem } from '../../../../components/pages/signin/find/password/FindPasswordPageItem';

export const getStaticProps = async ({ locale }: { locale: string }) => ({
  props: {
    ...(await serverSideTranslations(locale, ['common'])),
  },
  revalidate: 60,
});

function FindPasswordPage() {
  return <FindPasswordPageItem />;
}

FindPasswordPage.getLayout = (page: ReactElement) => (
  <AuthLayout
    meta={{
      title: '메타.비밀번호찾기.제목',
      description: '메타.비밀번호찾기.설명',
    }}
  >
    {page}
  </AuthLayout>
);

export default FindPasswordPage;
